import { combineReducers } from '@reduxjs/toolkit';

import accountReducer from './accountSlice';
import regionReducer from './regionSlice';
import authReducer from './authenticationSlice';
import notificationReducer from './notificationSlice';
import qualificationReducer from './qualificationSlice';
import clientReducer from './clientSlice';
import assignmentSlice from './assignmentSlice';
import partnerSlice from './partnerSlice';
import recruiterSlice from './recruiterSlice';
import dashboardSlice from './dashboardSlice';
import homeDashboardSlice from './homeDashboardSlice';
import onboardingSlice from './onboardingSlice';
import bullhornSlice from './bullhornSlice';
import workerSlice from './workerSlice';
import contractorCompanySlice from './contractorCompanySlice';
import achPaymentsSlice from './achPaymentsSlice';
import adminSlice from './adminSlice';

const rootReducer = combineReducers({
  account: accountReducer,
  auth: authReducer,
  region: regionReducer,
  notification: notificationReducer,
  qualification: qualificationReducer,
  client: clientReducer,
  assignment: assignmentSlice,
  partner: partnerSlice,
  recruiter: recruiterSlice,
  dashboard: dashboardSlice,
  homeDashboard: homeDashboardSlice,
  onboarding: onboardingSlice,
  bullhorn: bullhornSlice,
  worker: workerSlice,
  contractorCompany: contractorCompanySlice,
  achPayments: achPaymentsSlice,
  admin: adminSlice,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
